module.exports = __webpack_public_path__ + "static/media/page05_front.c5913edd.gif";